import classnames from 'classnames';
import React from 'react';
import styles from './ToggleButton.scss';
const ToggleButton = ({ children, onToggle, title = '', isOn = false, isFilterBar = false, }) => isFilterBar ? (<li className={classnames('pull-right', styles.buttonPosition)}>
      {children(title, onToggle, isOn)}
    </li>) : (children(title, onToggle, isOn));
export default ToggleButton;
